<template>
  <div class="search-gay-layer">
    <div class="search-gay-bar">
      <div class="search-input">
        <img class="search-icon" :src="`${currentTheme == 'dark' ? searchIconDark1 : searchIconLight1}`" @click.stop="searchAction()" />
        <input type="text" @input="searchBarInput" @keyup.enter="searchAction()" enterkeyhint="search"
          v-model.trim="keyWords" placeholder="输入您想搜索的内容">
      </div>
      <span class="cancle-btn" @click="$emit('cancleSearch')">取消</span>
    </div>
    <div class="search-page-container">
      <div class="recommend-keywords" v-if="keyWords">
        <h4>{{ keyWords }}<span>&nbsp;&nbsp;相关搜索结果</span></h4>
        <template v-if="showRecommends">
          <ul class="recommend-list" v-if="relatedData.length">
            <li v-for="item in relatedData" :key="item.id" @click="searchAction(item.title)">{{ item.title }}</li>
          </ul>
          <p v-else class="nothing">抱歉没有找到与此查询相关的视频</p>
        </template>
      </div>
      <HotTagsGay channel="search" v-if="!keyWords || (showRecommends && !relatedData.length)"
        @actionHotTag="(val: any) => searchAction(val.name)"></HotTagsGay>
    </div>
  </div>
</template>

<script lang="ts" setup name="SearchGayLayer">
import searchIconDark1 from "@/assets/images/dark/nantong/searchIconDark1.png"
import searchIconLight1 from "@/assets/images/light/nantong/searchIconLight1.png"
const globalStore = useGlobalStore();
const { currentTheme,resetWrapperHeight }: any = storeToRefs(globalStore)
const route = useRoute()
const searchStore = useSearchStore()
const emits = defineEmits(['cancleSearch'])
const { keyWords, scrollToTop, showRecommends, relatedData, pageNo, finished, loading, isRequested }: any = storeToRefs(searchStore);

const EDGE_THRESHOLD = 30
const handleTouchStart = (e: TouchEvent) => {
  if (e.touches[0].clientX < EDGE_THRESHOLD) {
    e.preventDefault()
  }
}
onMounted(() => {
  document.addEventListener('touchstart', handleTouchStart, { passive: false })
})
onUnmounted(() => {
  document.removeEventListener('touchstart', handleTouchStart)
})


const debouncedHandleInput = debounce(searchStore.searchRelated, 500);
const searchBarInput = () => {
  if (keyWords.value.length) {
    debouncedHandleInput()
  } else {
    // 如果输入框为空，清空搜索推荐并收起下拉框
    relatedData.value = []
  }
}

const searchAction = useThrottleFn(async (text?: string, tagId?: any) => {
  // 清空搜索推荐
  relatedData.value = []
  // 如果text参数存在就使用text，否则使用keyWords.value
  const searchText = text || keyWords.value

  if (!searchText) {
    return
  }
  // 导航前先移除监听，防止 v-if 异步卸载时监听泄漏到 search 结果页
  document.removeEventListener('touchstart', handleTouchStart)
  emits('cancleSearch')
  // 隐藏键盘
  const activeElement = document.activeElement as HTMLElement
  if (activeElement) {
    activeElement.blur()
  }

  if (route?.path != '/search') {
    isRequested.value = true;
    pageNo.value = 1;
    loading.value = false;
    finished.value = false;
    useRouter().replace({
      path: '/search',
      query: {
        tag: searchText
      }
    })

    searchStore.resultKeywords = searchText
    searchStore.searchMain(searchText)
  } else {
    await searchStore.searchMain(searchText)
  }
  setTimeout(() => {
    scrollToTop.value();
    resetWrapperHeight.value();
  },500);

}, 500)

</script>

<style lang="scss" scoped>
.search-gay-layer {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: calc(env(safe-area-inset-top)) 20px calc(env(safe-area-inset-bottom) + 10px) 20px;
  z-index: 1000;
  background: linear-gradient(170deg, rgba(255, 255, 255, 0.90) 6.3%, rgba(212, 212, 232, 0.90) 97.94%);
  backdrop-filter: blur(10px);

  // PC端：固定375px居中
  @media screen and (min-width: 751px) {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    width: 375px;
  }
  .search-page-container {
    height: calc(100vh - 70px);
    margin: 0 -20px;
    padding:0 20px;
    overflow: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
  }

  .recommend-keywords {
    .nothing {
      color: #8B8B8B;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 15px;
    }

    h4 {
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-bottom: 15px;
    }

    .recommend-list {
      li {
        color: #424242;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 10px;
      }
    }
  }

  .search-gay-bar {
    position: sticky;
    top: 0;
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0 20px 0;

    .search-input {
      position: relative;
      height: 100%;
      flex: 1;
      border-radius: 20px;
      background: #0B0B0B;
      padding: 0 11px 0 39px;
      display: flex;
      align-items: center;

      .search-icon {
        position: absolute;
        left: 11px;
        top: 11px;
        width: 18px;
        height: 18px;
      }

      input {
        display: block;
        width: 100%;
        height: 100%;
        background: none;
        font-size: 12px;
        font-weight: 400;
        line-height: 40px;

        &::-webkit-input-placeholder {
          color: #575757;
        }
      }
    }

    .cancle-btn {
      padding-left: 12px;
      font-size: 14px;
      font-weight: 400;
      color: #0b0b0b;
    }
  }
}
</style>
